import { Component } from '@angular/core';
import { AppService } from '../../App/app.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { NgZone } from '@angular/core';
import { MessageService } from '../message.service';

@Component({
  selector: 'app-question-header',
  templateUrl: './question-header.component.html',
  styleUrls: ['./question-header.component.css']
})
export class QuestionHeaderComponent {

  id:number; 

  generatable: boolean;
  showExerciseTip: boolean = true;

  constructor(public appService: AppService, protected _location: Location, public messageService: MessageService, protected router: Router, protected activedRoute: ActivatedRoute) { }

  ngOnInit(){
    this.id=this.appService.currentTeacherExercise.id;
    this.generatable = (typeof this.appService.currentTeacherExercise.generate === 'function');
  }

  /** action to call, when a bacjlink was clicked */
  backClicked() {
    this._location.back();
  }

  /** get text in right language 
 * @param {string} tag - text to load
 */
  get(tag: string): string {
    return this.appService.get(tag);
  }

  /** adds the current donfiguration to the global configuration */
  add() {
    this.appService.currentTeacherExercise.add();
    this.id = this.appService.currentTeacherExercise.id;
    this.messageService.addAlertWithTimeout(this.get("exerciseAdded"),"success", 10000);

  }

  /** updates the configuration */
  update() {
    this.appService.currentTeacherExercise.update();
    this.messageService.addAlertWithTimeout(this.get("exerciseUpdated"),"success", 10000);
  }

  /** route to the students view of the exercise */
  view(){
    this.router.navigateByUrl("/".concat(this.appService.currentTeacherExercise.chapterType(), this.appService.currentTeacherExercise.inExerciseSet() ? '/exam/'+ this.appService.currentTeacherExercise.examId : '', '/', this.appService.currentTeacherExercise.type, '/' , this.appService.currentTeacherExercise.id.toString() ), {relativeTo: this.activedRoute})
  }

  /** calls the current teacher exercise to generate */
  generate(){
    this.appService.currentTeacherExercise.generate();
  }

  /** calls the current teacher exercise to reset */
  reset(){
    this.appService.currentTeacherExercise.reset();
    this.id = undefined;
  }

  /** check if the exercise is part of a self-check exercise set */
  isExam():boolean{
    return this.appService.currentTeacherExercise.isExam();
  }

  /** check if the exercise is part of an exercise set */
  inExerciseSet():boolean{
    return this.appService.currentTeacherExercise.inExerciseSet();
  }

}
